module.exports = __webpack_public_path__ + "img/31ne.315b65a7.svg";